/**
 * https://shopify.dev/api/storefront/2023-01/queries/customer
 */

export const document = /* GraphQL */ `
  query shopifyStorefrontCustomer($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id # not-null
      firstName
      lastName
      email
      tags
      agzWelcomeBoxReceived: metafield(namespace: "custom", key: "agz_welcome_box_received") {
        key
        namespace
        value
        type
      }
    }
  }
`;
